import styled from 'styled-components'

import backgroundImage from './background.svg'

export default styled.div`
  width: 100%;
  display: flex;
  background-image: url('${backgroundImage}');
  background-repeat: no-repeat;
  background-position: 90% 100%;
  background-size: cover;
  padding: 8px 0 64px;
  margin-bottom: -5px;

  @media (min-width: 700px) {
    padding: 32px 0 64px;
    background-position: 90% 100%;
  }
`
